// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__nvRad","productName":"Table_productName__Q74pl"};